export default "__VITE_ASSET__ef389777__"